import { ProfileAvatarConnected } from "PFApp/components/profile_avatar_connected";
import { Avatar } from "PFComponents/avatar";
import { profileHash } from "PFCore/helpers/profile_hash";
import { ProfileNameLink } from "PFCore/helpers/profile_name_link";
import { useUnbiasedProfileName } from "PFCore/hooks/use_unbiased_profile_name";
import { Profile } from "PFTypes";

import Availability from "../../../profiles/common/availability";
import css from "./compare_availability_mobile_page.module.scss";

type CompareAvailabilityMobilePageProps = {
  profiles: Profile[];
  isUnbiasedMode?: boolean;
};

export const CompareAvailabilityMobilePage = ({
  profiles,
  isUnbiasedMode
}: CompareAvailabilityMobilePageProps) => {
  const { getUnbiasedProfileName } = useUnbiasedProfileName();

  return (
    <div className={css.root}>
      {profiles.map((profile) => (
        <div key={profile.id} className={css.item}>
          {isUnbiasedMode ? (
            <Avatar size={50} backgroundColor="#ffc0cb" text={profileHash(profile.id)} />
          ) : (
            <ProfileAvatarConnected profile={profile} size={50} />
          )}
          <div className={css.name}>
            {isUnbiasedMode ? (
              getUnbiasedProfileName(profile, isUnbiasedMode)
            ) : (
              <ProfileNameLink profile={profile} />
            )}
          </div>
          <Availability activeViews={["calendar"]} profile={profile} readOnly={true} isAdmin={undefined} />
        </div>
      ))}
    </div>
  );
};
